var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 38.15",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "waterline"
  }, "External Water Line Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "waterline"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47,27.8H45.19V9.93l1.46.86a.75.75,0,0,0,.76-1.3L31.73.32l-.09,0-.15,0h-.28l-.15,0L31,.32,15.29,9.49a.76.76,0,0,0-.26,1,.73.73,0,0,0,.64.37.75.75,0,0,0,.38-.1l1.46-.86V20.26H15.36v-.34s-1.08,0-2.26,0c-.6,0-1.21,0-1.73,0-3.21.12-3.45,2.65-3.45,2.91v4.29h.32v3.73H8v2.69H5v.3H.72a.38.38,0,1,0,0,.75H5V37.1H.72a.38.38,0,1,0,0,.75H5v.2s1.09,0,2.27,0c.59,0,1.21,0,1.73,0,3.2-.12,3.45-2.65,3.45-2.91V30.85h-.24v-1.6a.69.69,0,0,0,.24.05H47a.75.75,0,0,0,0-1.5Zm-15.68-26L43.69,9.06V27.8H35.9V17.56a.5.5,0,0,0-.5-.5l-.1,0-.11,0H27.25a.5.5,0,0,0-.5.5V27.8H19V9.06Zm-3.6,16.22H34.9V27.8H27.75ZM17.51,21v2.51H15.36V21ZM8.67,22.84c0-.09.08-2.07,2.73-2.17.51,0,1.11,0,1.7,0h1.51v3H11.68v2.69h-3ZM9,37.3c-.51,0-1.12,0-1.7,0H5.78v-3H8.71V31.6h3v3.53C11.73,35.22,11.65,37.2,9,37.3Zm0-6.45V27.12h2.5v3.73Zm3.25-3v-.73h.19V24.43h2.93v-.16h2.15V27.8h-5A.69.69,0,0,0,12.24,27.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalWater);
export default __webpack_public_path__ + "static/media/external-water.c62e28741234e0d2b316f643a5139bbc.svg";
export { ForwardRef as ReactComponent };